export default __webpack_public_path__ + "static/media/kitchen3-afterK-1920w.0b460275.webp";